React = require 'react'
{ featureFlagClient } = require '@trello/feature-flag-client'
Util = require 'app/scripts/lib/util'
# Using `board_menu_vis` here to share strings from old template
t = require('app/scripts/views/internal/recup-with-helpers')('board_menu_vis')

VIS_OPTIONS = [
  { value: 'private', icon: 'private' }
  { value: 'public', icon: 'public' }
]

ORG_VIS_OPTIONS = [
  { value: 'private', icon: 'private' }
  { value: 'org', icon: 'organization' }
  { value: 'public', icon: 'public' }
]

ENTERPRISE_VIS_OPTIONS = [
  { value: 'private', icon: 'private' }
  { value: 'org', icon: 'organization' }
  { value: 'enterprise', icon: 'enterprise' }
  { value: 'public', icon: 'public' }
]

module.exports = class VisChooserComponent extends React.Component
  displayName: 'VisChooserComponent'

  componentDidMount: ->
    setTimeout (=> @chooserElem?.focus()), 10

  render: t.renderable ->
    { onSelect, selectedOrg, selectedVis } = @props
    if selectedOrg?
      if selectedOrg.model.belongsToRealEnterprise()
        options = ENTERPRISE_VIS_OPTIONS
      else
        options = ORG_VIS_OPTIONS
    else
      options = VIS_OPTIONS
    hasSuperAdmins = selectedOrg? && selectedOrg.model.isFeatureEnabled 'superAdmins'
    setChooserElem = (elem) => @chooserElem = elem

    t.ul '.pop-over-list.vis-chooser', { ref: setChooserElem, tabIndex: 0 }, ->
      options.forEach (vis) ->
        isDisabled = selectedOrg? && selectedOrg.allowedVis.indexOf(vis.value) == -1
        isSelected = vis.value == selectedVis

        t.li ->
          t.a {
            className: t.classify { disabled: isDisabled }
            href: '#'
            onClick: (e) ->
              if isDisabled then return

              Util.stop e
              onSelect vis.value
          }, ->
            t.icon vis.icon
            t.format vis.value
            if isSelected
              t.icon 'check'
            t.span '.sub-name', ->
              if hasSuperAdmins
                t.format ['permission subtext', 'with super admins', vis.value], { orgName: selectedOrg.model.get 'displayName' }
              else if selectedOrg?
                t.format ['permission subtext', 'with organization', vis.value], { orgName: selectedOrg.model.get 'displayName' }
              else
                t.format ['permission subtext', 'without organization', vis.value]

              if isDisabled
                t.raw '&nbsp;'
                t.span '.error', ->
                  t.format ['illegal visibility', 'create']
